import React, { FC } from 'react'
import { UnexpectedError } from '../Shared/Error'
import { Spinner } from '../Shared/Spinner'
import { ManageSubscription } from './ManageSubscription'
import { useGetSubscriptionDetails } from './SubscriptionApi'
import { IPowerBiReports } from '../../Models/GlobalState'
import { TOGGLENAME } from '../../ts/enums/releaseToggles'
import { DefaultPage } from '@tnwinc/navex-react'

interface IProps {
    reportsLeftNavMenu: IPowerBiReports[],
    email: string,
    toggles: string[],
    productPermissions: string[]
}

export const SubscriptionRoute: FC<IProps> = (props) => {
    const email = props.email

    const reports: string[] = props.reportsLeftNavMenu.map((item: any) => {
        if (!props.toggles.includes(TOGGLENAME.SUBSCRIBEBYEMAILDM) && item.leftNavName === 'Disclosure Management') {
            return '';
        }
        return item.powerBiReports;
    }).filter(report => report !== '');
    const [{ SubscriptionDetails, loading, errors, status }, reFetchData] = useGetSubscriptionDetails(props.toggles.includes(TOGGLENAME.SUBSCRIBEBYEMAIL))

    if (errors.length) return <UnexpectedError />
    if (loading || !status) return <Spinner />

    return (
        <DefaultPage>
            <ManageSubscription SubscriptionDetails={SubscriptionDetails} refetch={reFetchData} leftNavMenu={reports} email={email} productPermissions={props.productPermissions}/>
        </DefaultPage>)
}